/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItem_user$ref = any;
export type PdpRespSimilarItemsGrid_user$ref = any;
export type PdpRespSimilarItemsGrid_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": PdpRespSimilarItem_user$ref;
    readonly " $refType": PdpRespSimilarItemsGrid_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsGrid_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItem_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'f75bd8f8dbfd2cf0c25719e068ba0cbd';
export default node;
